import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ChevronRight } from "lucide-react";

export default function NonConformitaCard({ to = "/non-conformita" }) {
    const navigate = useNavigate();

    return (
        <section>
            <h3 className="text-[28px] leading-[33px] font-light text-[#454545] mb-3">
                Non conformità
            </h3>

            <button
                type="button"
                onClick={() => navigate(to)}
                className="w-full text-left bg-white border border-slate-200 rounded-2xl p-4 hover:bg-slate-50 transition"
                style={{
                    boxShadow:
                        "0px 20px 25px rgba(0,0,0,0.10), 0px 2px 4px rgba(0,0,0,0.10)",
                }}
            >
                <div className="flex items-center justify-between gap-3">
                    <div className="flex items-center gap-3 min-w-0">
                        <div className="h-11 w-11 rounded-2xl bg-slate-100 border border-slate-200 grid place-items-center shrink-0">
                            <AlertTriangle size={20} className="text-[#454545]" />
                        </div>

                        <div className="min-w-0">
                            <div className="text-sm font-semibold text-slate-800">
                                Vai al modulo Non conformità
                            </div>
                            <div className="text-sm text-slate-500 truncate">
                                Gestisci audit, segnalazioni e azioni correttive (placeholder)
                            </div>
                        </div>
                    </div>

                    <div className="h-10 w-10 rounded-full bg-slate-200 grid place-items-center shrink-0">
                        <ChevronRight size={18} className="text-[#454545]" />
                    </div>
                </div>
            </button>
        </section>
    );
}